import { useIntl } from '@grandvisionhq/state';
import { getCustomShortDateFormat } from '../../../utils/get-custom-short-date-format.js';

const useRangeByWeeks = (weeks)=>{
    const { locale  } = useIntl();
    const firstWeek = weeks[0];
    const [lastWeek] = weeks.slice(-1);
    const firstDay = firstWeek[0];
    const [lastDay] = lastWeek.slice(-1);
    return `${getCustomShortDateFormat(firstDay, locale)} - ${getCustomShortDateFormat(lastDay, locale)}`;
};

export { useRangeByWeeks };
//# sourceMappingURL=use-range-by-weeks.js.map
